import React from 'react';
import { Box } from '@mui/material';

/**
 * Simple illustrated "room" scenes (SVG) — switches by category.
 */
export default function RoomIllustration({ category = 'home', accent = '#1565c0', soft = '#e3f2fd' }) {
  const scenes = {
    home: (
      <g>
        <rect x="40" y="120" width="320" height="160" rx="8" fill={soft} stroke={accent} strokeWidth="2" />
        <rect x="70" y="80" width="100" height="50" rx="4" fill="#fff" stroke={accent} strokeWidth="1.5" opacity="0.9" />
        <rect x="220" y="90" width="90" height="40" rx="4" fill="#fff" stroke={accent} strokeWidth="1.5" opacity="0.9" />
        <rect x="120" y="200" width="140" height="35" rx="6" fill={accent} opacity="0.25" />
        <rect x="100" y="175" width="50" height="45" rx="4" fill={accent} opacity="0.4" />
        <circle cx="300" cy="210" r="18" fill={accent} opacity="0.35" />
        <path d="M60 280 L340 280" stroke={accent} strokeWidth="2" opacity="0.3" />
      </g>
    ),
    garden: (
      <g>
        <rect x="30" y="200" width="340" height="80" fill="#c8e6c9" opacity="0.5" />
        <path d="M80 200 Q120 120 160 200" fill="#66bb6a" opacity="0.7" />
        <path d="M200 200 Q250 100 300 200" fill="#43a047" opacity="0.6" />
        <rect x="250" y="150" width="80" height="60" rx="4" fill="#8d6e63" opacity="0.5" stroke={accent} strokeWidth="1.5" />
        <rect x="90" y="220" width="50" height="8" rx="2" fill="#795548" opacity="0.6" />
        <circle cx="320" cy="230" r="25" fill={accent} opacity="0.2" />
        <path d="M50 280 L350 280" stroke={accent} strokeWidth="2" opacity="0.25" />
      </g>
    ),
    office: (
      <g>
        <rect x="50" y="130" width="300" height="150" rx="6" fill={soft} stroke={accent} strokeWidth="2" />
        <rect x="120" y="170" width="120" height="12" rx="2" fill={accent} opacity="0.35" />
        <rect x="140" y="120" width="80" height="50" rx="3" fill="#fff" stroke={accent} strokeWidth="1.5" />
        <rect x="220" y="200" width="40" height="50" rx="3" fill={accent} opacity="0.3" />
        <circle cx="100" cy="210" r="22" fill={accent} opacity="0.25" />
        <path d="M60 280 L340 280" stroke={accent} strokeWidth="2" opacity="0.3" />
      </g>
    ),
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: 400 },
        mx: 'auto',
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1,
        maxHeight: { xs: 200, sm: 'none' },
      }}
    >
      <svg viewBox="0 0 400 300" width="100%" height="auto" role="img" aria-label={`${category} illustration`}>
        <defs>
          <linearGradient id={`sky-${category}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={soft} />
            <stop offset="100%" stopColor="#ffffff" />
          </linearGradient>
        </defs>
        <rect width="400" height="300" fill={`url(#sky-${category})`} />
        {scenes[category] || scenes.home}
      </svg>
    </Box>
  );
}
